module.exports = __webpack_public_path__ + "img/vg.a796b16d.svg";